module.exports = __webpack_public_path__ + "img/BuinzooLogo.e7c89ab5.png";